import React from 'react';
import { Box, Stack, Typography, Button, Container } from '@mui/material';
import { alpha } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const Success = () => {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                width: '100%',
                backgroundColor: '#EFDDD0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Container maxWidth="sm">
                <Stack 
                    spacing={4} 
                    alignItems="center"
                    sx={{
                        backgroundColor: '#fff',
                        borderRadius: 2,
                        padding: { xs: 4, sm: 6 },
                        boxShadow: 3,
                        textAlign: 'center',
                    }}
                >
                    {/* 成功图标 */}
                    <CheckCircleIcon 
                        sx={{ 
                            fontSize: 80, 
                            color: '#EF7F95',
                            '&:hover': {
                                color: alpha('#EF7F95', 0.8)
                            },
                        }} 
                    />

                    {/* 标题 */}
                    <Typography 
                        variant="h4" 
                        component="h1" 
                        sx={{ 
                            fontWeight: 700,
                            color: '#333',
                        }}
                    >
                        支付成功！
                    </Typography>

                    {/* 订单信息提示 */}
                    <Typography 
                        variant="body1" 
                        sx={{ 
                            color: '#666',
                            lineHeight: 1.8,
                            fontSize: 16,
                        }}
                    >
                        感谢您的购买！
                        <br />
                        订单信息及课程链接已发送至您的邮箱，请注意查收。
                        <br />
                        <Typography 
                            component="span" 
                            variant="body2" 
                            sx={{ 
                                color: '#999',
                                fontSize: 14,
                            }}
                        >
                            （如未收到邮件，请检查垃圾邮件箱）
                        </Typography>
                    </Typography>

                    {/* 分隔线 */}
                    <Box 
                        sx={{ 
                            width: '100%', 
                            height: '1px', 
                            backgroundColor: '#eee',
                            my: 1,
                        }} 
                    />

                    {/* Excel AI 助手链接 */}
                    <Button
                        variant="contained"
                        fullWidth
                        href="https://mica.mindlink.tools"
                        target="_blank"
                        rel="noopener noreferrer"
                        startIcon={<AutoAwesomeIcon />}
                        sx={{
                            backgroundColor: '#EF7F95',
                            color: '#fff',
                            height: 48,
                            fontSize: 16,
                            fontWeight: 600,
                            borderRadius: 2,
                            textTransform: 'none',
                            '&:hover': {
                                backgroundColor: alpha('#EF7F95', 0.8),
                            },
                        }}
                    >
                        打开 Excel AI 助手
                    </Button>

                    {/* 返回首页按钮 */}
                    <Button
                        variant="outlined"
                        fullWidth
                        href="/"
                        startIcon={<ArrowBackIcon />}
                        sx={{
                            color: '#EF7F95',
                            borderColor: '#EF7F95',
                            height: 48,
                            fontSize: 16,
                            borderRadius: 2,
                            textTransform: 'none',
                            '&:hover': {
                                borderColor: alpha('#EF7F95', 0.8),
                                backgroundColor: alpha('#EF7F95', 0.05),
                            },
                        }}
                    >
                        返回首页
                    </Button>
                </Stack>
            </Container>
        </Box>
    );
};

export default Success;
